import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "firstFunction4";
const idNext = "firstFunction5";
const idPrev = "firstFunction3";

const next = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
        choices:
          - choice: Peter
          - choice: Edmund
          - choice: Susan
      - parameter: Antagonist
      - parameter: Weapon
      - parameter: Location
`;

const prev = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
`;

function ManualFirstFunction4({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-ff4"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Now that we have all our parameters, it’s time to populate them with choices. First
              let’s finish our <b>Protagonist</b>.
            </p>
            <p>
              to add a choice click the <b>ADD CHOICE</b> button and then give it a name. You can
              easily add another choice once you’ve made the first one by clicking the <b>enter</b>{" "}
              button on your keyboard.
            </p>
            <p>
              Let’s add the choices for our Protagonist, <b>Peter</b>, <b>Edmund</b> and{" "}
              <b>Susan</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateFirstFunction4 = (root, tutorial, setTutorial) => {
  if (tutorial === id) {
    let { res: resFun } = tutorialUtils.validateSingleFunction(root, "Duel");

    if (!resFun) {
      return false;
    }

    let { res: resParam } = tutorialUtils.validateParameterChoices(
      root,
      false,
      false,
      "Protagonist",
      ["Peter", "Edmund", "Susan"],
    );

    if (!resParam) {
      return false;
    }

    setTutorial(idNext);

    return true;
  }

  return false;
};

export default ManualFirstFunction4;
